<template>
  <navbar>
    <my-button @click="$router.push('/profile')">profile</my-button>
  </navbar>

  <my-dialog v-model:show="showOrder">
    <barman-cocktail :order="order" :key="order.order_id" @hide-event="showOrder=false"></barman-cocktail>
  </my-dialog>

  <div class="head">
    <div class="username">Barman {{ username }}</div>
    <div v-if="isBarman" class="barman">
      <my-button @click="$router.push('/barman/cocktails')">Cocktails</my-button>
    </div>
  </div>

  <div class="block">
    <div class="name">
      Order
    </div>
    <div style="text-align: right;">
      <input type="checkbox" id="history" v-model="allOrder">
      <label for="history">history</label>
    </div>

    <div class="border">
      <div class="cocktail" v-for="order in orders.filter(order => order.status != 'history' || allOrder)"
        :class="{
          'border_gray': order.status == 'ordering', 'border_cook': order.status == 'cook',
          'border_ready': order.status == 'ready','border_history': order.status == 'history'
        }"
        @click="viewCocktail(order)"
        :key="order.order_id"
      >
        <div>
          <img style="height: 150px;" src="/api/static/icons/cocktail (20231105111207).png"></img>
        </div>
        <div>
          <div class="cocktail_name">{{ order.cocktail.name }}
            <div class="alc" v-if="order.cocktail.alcohols">Alc</div>
          </div>
          <div>заказчик: {{ order.username }}</div>
          <div :class="{
            'color_gray': order.status == 'ordering', 'color_cook': order.status == 'cook',
            'color_ready': order.status == 'ready', 'color_history': order.status == 'history'
          }">статус: {{ order.status }}</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Navbar from '@/components/Navbar.vue';
import BarmanCocktail from '@/components/BarmanCocktail.vue';
// import ky from 'ky';

export default {
  components: {
    Navbar, BarmanCocktail
  },
  data() {
    return {
      username: '',
      isBarman: false,
      orders: [],
      interval_id: null,
      allOrder: false,

      showOrder: false,
      // activeOrder: null,
      order: null,
    }
  },
  methods: {
    async get_order() {
      let res = await fetch('/api/barman/get_order', {
        method: "GET",
        headers: {"content-type": "application/json"},
      })
      if (res.status === 200) {
        let data = await res.json();
        // console.log(data);
        this.orders = data['order'];
      }
    },
    async viewCocktail(order) {
      this.order = order;
      // this.activeOrder = order.order_id;
      this.showOrder = true;
    },
    async isauth() {
      let res = await fetch('/api/auth/isauth', {
        method: "POST",
        headers: {"content-type": "application/json"},
      });
      if (res.status === 200) {
        let data = await res.json();
        // console.log(data['auth']);
        if (!data['auth']) {
          this.$router.push('/auth/log_in');
        }
      }
    },
    async isbarman() {
      let res = await fetch('/api/barman/isbarman', {
        method: "POST",
        headers: {"content-type": "application/json"},
      });
      if (res.status === 200) {
        let data = await res.json();
        // console.log(data['auth']);
        if (!data['auth']) {
          this.$router.push('/auth/log_in');
        } else {
          this.username = data['username'];
          this.isBarman = data['isBarman'];
        }
      }
    }
  },
  mounted() {
    this.isbarman();
    this.get_order();
    // let interval_id = setInterval(this.get_order, 5000);
    this.interval_id = setInterval(this.get_order, 5000);
  },
  beforeUnmount() {
    clearInterval(this.interval_id);
  }
}
</script>


<style scoped>
.head {
  margin-top: 50px;
}
.username {
  font-size: 75px;
  text-align: center;
}

.barman {
  display: flex;
  flex-direction: column;
  width: max-content;
  margin: auto;
}

.block {
  margin: 15px;
}
.name {
  font-size: 75px;
  text-align: center;
  margin-top: 100px;
}

input[type='checkbox'] {
  width: 30px;
  height: 30px;
}

.border {
  display: flex;
  flex-direction: column;
  gap: 10px;

  border: 6px solid var(--bar-color-main);
  padding: 15px;
  border-radius: 15px;
}

.cocktail {
  display: flex;
  /* margin-top: 15px; */
  padding: 5px;
  border: 6px solid var(--bar-color-main);
  border-radius: 15px;
}
.border_gray {
  border: 5px solid gray;
}
.border_cook {
  border: 5px solid orange;
}
.border_ready {
  border: 5px solid lightgreen;
}
.border_history {
  border: 5px solid black;
}
.color_gray {
  color: gray;
}
.color_cook {
  color: orange;
}
.color_ready {
  color: lightgreen;
}
.color_history {
  color: black;
}

.cocktail_name {
  display: flex;
  /* color: black; */
  font-size: 50px;
  padding: 15px;
  /* align-self: center; */
  /* align-content: center; */
  align-items: center;
}
.alc {
  margin-left: 25px;
  color: HotPink;
  font-size: 50px;
}
</style>
